'use strict';

var _ = require('lodash');
var tooltipTemplate = _.template(require('../templates/chart-fares-tooltip-template.html'));
var tooltipGapTemplate = _.template(require('../templates/chart-fares-tooltip-gap-template.html'));
var ChartClassUsageController = function ChartClassUsageController($scope, $rootScope, chartFaresService, $filter) {
  var rmNumberFilter = $filter('rmNumberFormat');
  $scope.reloadChart = function () {
    if (!$scope.chartModel) {
      return;
    }
    $scope.renderChart($scope.chartModel.data, $scope.chartModel.ranges[0]);
  };
  $scope.rangeChangeHandler = function (ranges, clearBrushes) {
    $scope.chartModel.ranges = ranges;
    $scope.chartModel.selectedClasses = chartFaresService.getSelectedData($scope.chartModel.data, ranges);
    $scope.selectionHandler();
    if (clearBrushes) {
      $rootScope.$broadcast('chart-class-usage:clearBrushSelection', $scope.chartModel.cabinCode);
    }
  };
  $scope.createTooltipFormatter = function () {
    var tooltipFormatter = function tooltipFormatter(d) {
      if (d.isGap) {
        return tooltipGapTemplate({
          text: d.tooltipLabel
        });
      }
      var wholeData = $scope.chartModel.data;
      var dataForTooltip = chartFaresService.parseChartDataForTooltip(wholeData, d, $scope.legend);
      var cssClass = '';
      if (dataForTooltip.length > 5) {
        cssClass = 'fares-chart-tooltip-legend-columns';
      }
      return tooltipTemplate({
        cssClass: cssClass,
        clazz: d.clazz,
        chartData: dataForTooltip,
        avgFares: rmNumberFilter(d.avgFare, 'NUMBER'),
        prevAvgFares: rmNumberFilter(d.prevAvgFare, 'NUMBER')
      });
    };
    tooltipFormatter.cssClass = 'fares-class-usage-tooltip';
    return tooltipFormatter;
  };
  $scope.$watchGroup(['chartModel.data', 'sizingParams.containerWidth'], function () {
    $scope.reloadChart();
  });
};
ChartClassUsageController.$inject = ['$scope', '$rootScope', 'ChartFaresService', '$filter', '$timeout'];
module.exports = ChartClassUsageController;